module.exports = __webpack_public_path__ + "static/img/zs.f0851d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zs.png
// module id = ZW4A
// module chunks = 0